const sizes = {
  default: 'default',
  small: 'small',
};

export default sizes;
